// Deterministic shuffle based on key to keep choices stable across reloads
function seedShuffle(arr, seedStr) {
  const a = arr.slice();
  // simple LCG seeded by sum of char codes
  let seed = 0;
  for (let i = 0; i < seedStr.length; i++) seed = (seed + seedStr.charCodeAt(i)) >>> 0;
  const rand = () => {
    seed = (seed * 1664525 + 1013904223) >>> 0; // LCG
    return (seed >>> 1) / 0x7fffffff;
  };
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(rand() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

const base = {
  "1L": {
    "key": "1L",
    "text": "lnyz",
    "group": "p1",
    "scored": true,
    "type": "text"
  },
  "1E": {
    "key": "1E",
    "text": "eail",
    "group": "p1",
    "scored": true,
    "type": "text"
  },
  "1P": {
    "key": "1P",
    "text": "puyz",
    "group": "p1",
    "scored": true,
    "type": "text"
  },
  "1A": {
    "key": "1A",
    "text": "aebd",
    "group": "p1",
    "scored": true,
    "type": "text"
  },
  "1W": {
    "key": "1W",
    "text": "wyde",
    "group": "p1",
    "scored": true,
    "type": "text"
  },
  "1I": {
    "key": "1I",
    "text": "iope",
    "group": "p1",
    "scored": true,
    "type": "text"
  },
  "1G": {
    "key": "1G",
    "text": "gjln",
    "group": "p1",
    "scored": true,
    "type": "text"
  },
  "1Y": {
    "key": "1Y",
    "text": "yzig",
    "group": "p1",
    "scored": true,
    "type": "text"
  },
  "1D": {
    "key": "1D",
    "text": "dbgj",
    "group": "p1",
    "scored": true,
    "type": "text"
  },
  "1O": {
    "key": "1O",
    "text": "opwy",
    "group": "p1",
    "scored": true,
    "type": "text"
  },
  "1J": {
    "key": "1J",
    "text": "jluw",
    "group": "p1",
    "scored": true,
    "type": "text"
  },
  "1B": {
    "key": "1B",
    "text": "bdeg",
    "group": "p1",
    "scored": true,
    "type": "text"
  },
  "1U": {
    "key": "1U",
    "text": "uwab",
    "group": "p1",
    "scored": true,
    "type": "text"
  },
  "1N": {
    "key": "1N",
    "text": "nopu",
    "group": "p1",
    "scored": true,
    "type": "text"
  },
  "1Z": {
    "key": "1Z",
    "text": "zajl",
    "group": "p1",
    "scored": true,
    "type": "text"
  }
};

// Build enriched entries with answerKey (one letter from text) and randomized choices
// Ensure no letter is repeated as answerKey across all questions
const usedLetters = new Set();
const part1 = Object.fromEntries(
  Object.entries(base).map(([k, v]) => {
    const letters = v.text.split('');
    const shuffled = seedShuffle(letters, k);
    
    // Find first letter that hasn't been used yet from shuffled array
    let answerKey = null;
    for (const letter of shuffled) {
      const lowerLetter = letter.toLowerCase();
      if (!usedLetters.has(lowerLetter)) {
        answerKey = lowerLetter;
        usedLetters.add(lowerLetter);
        break;
      }
    }
    
    // If no unused letter found in shuffled array, find any unused letter from original text
    if (!answerKey) {
      for (const letter of letters) {
        const lowerLetter = letter.toLowerCase();
        if (!usedLetters.has(lowerLetter)) {
          answerKey = lowerLetter;
          usedLetters.add(lowerLetter);
          break;
        }
      }
    }
    
    // If still no answerKey found, this means all letters in this question are already used
    // In this case, we need to reassign - find the first letter that appears in this question
    // and hasn't been used yet (this shouldn't happen with proper data)
    if (!answerKey) {
      // This is a fallback that shouldn't be needed with 15 unique letters and 15 questions
      answerKey = (letters[0] || '').toLowerCase();
      console.warn(`Warning: All letters in ${k} are already used, using fallback: ${answerKey}`);
    }
    
    return [k, { ...v, answerKey }];
  })
);

export const audioTemplate = "https://d3vx0tne0vxeo1.cloudfront.net/fl/0/p1/part1-{{key}}.mp3";
export default part1;